module.exports = __webpack_public_path__ + "static/media/CostToOwnAwards.3b15c331.png";